const PREVIEW_LINK = /\/p\/([A-Za-z0-9_-]{8,})/

/** Token of the newest preview link the agent sent, or null when none was sent. */
export function latestPreviewToken(
  messages: { direction: 'inbound' | 'outbound'; content: string }[]
): string | null {
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].direction !== 'outbound') continue
    const match = PREVIEW_LINK.exec(messages[i].content)
    if (match) return match[1]
  }
  return null
}
